$(function(){

    if( $("body").is("#spot.detail") ){

        // purl
        var active = $.url().param("active");

        if(active){
            $(".post-body").attr("data-active", active);
            $(".post-body [data-href='"+ active +"']").addClass("active");
            $(".post-body .cont").removeClass("active");
            $(".cont.cont-" + active).addClass("active");
        }

        var tabLen = $(".post-body .tab-list li").length;
        $(".post-body .tab-list").attr("data-count", tabLen);

        // // social button
        // //------------------------------------------------------------
        // var shareUrl = encodeURI(document.URL);
        // // var shareUrl = encodeURI("http://www.biwako-visitors.jp/");
        // var shareTitle = encodeURI(document.title);
        // var snsBox = $(".title-set .sns");

        // // var domain = document.URL.split('/kyoto/')[0];
        // // var domain = "http://www.biwako-visitors.jp";
        // // var ogimage = "/design/img/ogp.png";

        // var twitterURL = "//twitter.com/intent/tweet?text=" + shareTitle + "&url=" + shareUrl;
        // var facebookURL = "//www.facebook.com/sharer.php?u=" + shareUrl;
        // var lineURL = "//line.me/R/msg/text/?" + "[" + shareTitle + "]" + "[" + shareUrl + "]";

        // $(".twitter a", snsBox).attr("href", twitterURL);
        // $(".facebook a", snsBox).attr("href", facebookURL);
        // $(".line a", snsBox).attr("href", lineURL);

        // $("a", snsBox).attr("target", "_blank");

        // $(".google a", snsBox).attr("href", "//plus.google.com/share?url=" + shareUrl);
        // $(".pinterest a", snsBox).attr("href", "//pinterest.com/pin/create/button/?url="+ shareUrl +"&media="+ domain + ogimage +"&description=" + shareTitle);

        // tab changer
        //------------------------------------------------------------
        $(".post-body .tab-list [data-href], .banner-list [data-href], .cont-title[data-href]").on('tap', function(){

            var $t = $(this);

            var id = $t.attr("data-href");
            $(".post-body").attr("data-active", id);

            // PC版の動き
            if( $t.is("a") ){
                $(".post-body .tab-list [data-href]").removeClass("active");
                $(".post-body .banner-list [data-href]").removeClass("active");
                $(".post-body .cont").removeClass("active");

                $(".post-body  .tab-list [data-href='"+ id +"']").addClass("active");
                $(".post-body  .banner-list [data-href='"+ id +"']").addClass("active");
                $(".cont.cont-" + id).addClass("active");
            }

            // SP版はcont-titleの位置に移動
            if( $t.hasClass("cont-title") ){
                $t.toggleClass("active");
                $(".cont.cont-" + id).toggleClass("active");
            }

            // slick バグ対応
            if(id == "basic" || id == "eemon"){
                if( $(".slider-cont .item").length > 1 ){
                     $(".slider-cont").slickNext();
                }

                if( $("#block-eemon .item").length > 1 ){
                    $("#block-eemon .photo").slickNext();
                }
            }

            if(id == "hana"){
                $(".cont-hana .posts").masonry();
            }
        });

        // tooltip
        $(".post-head .icon-list li a").each(function(){
            var text = $(this).text();
            $(this).data("powertip", text);
        });
        $(".post-head .icon-list li a").powerTip({
            fadeInTime: 50,
            fadeOutTime: 50,
            offset: 5
        });

        // banner 0件の場合の処理
        if( $(".cont-basic .banner-list li").length === 0 ){
            $(".cont-basic .main-img").addClass("js-nobanner");
        }

        // masonry
        $(window).on('load', function(){
            $(".cont-hana .posts").masonry();
        });

        // basicタブ slick設定
        var bgARR = [];
        $('.slider-cont .item').each(function(i){
            var bgi = $(".img", this).data("bgi");
            bgARR.push(bgi);
        });

        if( $('.slider-cont .item').length > 1 ){
            $('.slider-cont').slick({
                dots: true,
                fade: true,
                // autoplay: true,
                arrows: false,
                customPaging: function(slider, i) {
                    // return '<button type="button" data-role="none">' + (i + 1) + '</button>';
                    return '<div class="slick-pager-item" style="background-image: url('+ bgARR[i] +')">'+ (i + 1)  +'</div>';
                }
            });
        }

        // eemonタブ slick設定
        var bgARR2 = [];
        $('#block-eemon .photo .item').each(function(){
            var bgi = $(".img", this).data("bgi");
            bgARR2.push(bgi);
        });

        if( $('#block-eemon .photo .item').length > 1 ){
            $('#block-eemon .photo').slick({
                dots: true,
                fade: true,
                // autoplay: true,
                arrows: false,
                customPaging: function(slider, i) {
                    return '<div class="slick-pager-item" style="background-image: url('+ bgARR2[i] +')">'+ (i + 1)  +'</div>';
                }
            });
        }

        // // moreボタン
        // //------------------------------------------------------------
        // var moreTarget = $(".cont-basic, .cont-spot, .cont-eat, .cont-shop, .cont-stay");
        // $(".texts p:eq(0), .text-about p:eq(0)", moreTarget).each(function(){
        //     var len = $(this).text().length;
        //     //

        //     if( len > 300 ){
        //         $(this).addClass("js-over");
        //         $(this).wrapInner('<span></span>');
        //         $(this).after('<p class="bt-more"><a href="javascript:void(0);">続きを表示</a></p>');
        //     }
        // });

        // $(".cont .bt-more a").live('tap', function(){
        //     var that = $(this).parents().filter(".cont");
        //     $(this).remove();
        //     $(".js-over", that).removeClass("js-over");
        // });

        // gmap関係
        //------------------------------------------------------------
        if( $("#gmap").length > 0 ){

            var par = $(".box-map");

            // 結果表示ボタン
            par.toggleGroup();
            $("#root-results .bt-results a").toggleSwitch();

            // // ルート検索実行
            // $(".bt-create").on('tap', function(event){
            //     $(".bt-app .root a").removeClass("active");
            //     $(".block-root").slideUp(300);
            //     event.preventDefault();
            //     searchRoute();
            // });

            // // GoogleMapsで検索
            // $(".bt-gmapCreate").on("tap", function(event){
            //     event.preventDefault();
            //     var params = {
            //         hl: "ja",
            //         ie: "UTF-8",
            //         dirflg: "w",
            //         z: 11
            //     };
            //     var way = [];

            //     $(".root-list li").each(function(){
            //         var val = $("dd input", this).val();

            //         if( $("dd input", this).attr("data-latlng") ){
            //             val = $("dd input", this).attr("data-latlng");
            //         }
            //         if( $(this).is(":first-child") ){
            //             params.saddr = val;
            //         } else if (val) {
            //             if (way.length > 0) {
            //                 val = "to:" + val;
            //             }
            //             way.push(val);
            //         }
            //     });
            //     var daddr = way.join(" ");
            //     params.daddr = daddr;
            //     var url = "https://maps.google.co.jp/maps?" + $.param(params);
            //     window.open(url, "_blank");
            // });

            // この条件で表示
            $(".bt-view").on('tap', function(event){
                $(".bt-app .pin a").removeClass("active");
                $(".map-category").slideUp(300);
                // searchRoute();
            });

            // bt-close
            $(".block-root .bt-close, .map-category .bt-close").on('tap', function(){
                // スマホの二重クリック対策
                setTimeout(function(){
                    $(".map-category, .block-root").slideUp(300);
                    $(".bt-app a").removeClass("active");
                }, 400);
            });

            // Colorbox
            $(".block-root .bt-subSearch a, .block-root dl dd").live('click', function(){
                var that = $(this).parents().filter("li");
                var href = $("[data-iframe]", that).attr("data-iframe");


                $.colorbox({
                    href: href,
                    iframe: true,
                    maxWidth:'96%',
                    maxHeight:'96%',
                    innerWidth:800,
                    innerHeight:600,

                    onOpen: function(i) {
                        $(".root-list input").removeAttr("data-target");
                        $("input", that).attr("data-target", "true");
                    }
                });
            });

        }
    }
});



// WEBPACK FOOTER //
// ./_src/js/cont/spot-detail.js